import React from "react";
import { useTranslation } from "react-i18next";

//MUI
import { Box, Stack, Typography, Tooltip } from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";

// Components
import { MNButton } from "Common/Components";
import { QRCode } from "Components/QRCode";

// Styles
import { styles } from "./styles";
import { styles as buttonStyles } from "Common/Styles/ButtonStyles";

const TruncateText = (text, maxLength) => {
  if (text?.length > maxLength) {
    return { truncated: true, text: text.slice(0, maxLength) + "..." };
  }
  return { truncated: false, text };
};

const PatientInfoHeader = ({
  onBackClick,
  patient,
  title,
  allowQRcode = false,
  onQrSuccess,
}) => {
  const { t } = useTranslation();

  const getInitials = () =>
    patient?.firstName.charAt(0) + patient?.lastName.charAt(0);

  const truncatedFirstName = TruncateText(patient?.firstName || "", 10);
  const truncatedLastName = TruncateText(patient?.lastName || "", 10);

  return (
    <Stack sx={styles.mainStack}>
      <Stack sx={styles.headerStack}>
        <Stack direction="row" sx={styles.backAndTitleStack(patient)}>
          <MNButton
            ariaLabel="buttons.back"
            sx={buttonStyles.backButton}
            onClick={onBackClick}
          >
            <ArrowBackIcon />
            <Typography>{t("buttons.back")}</Typography>
          </MNButton>
          <Typography sx={styles.header}>{title}</Typography>
        </Stack>
        {allowQRcode && <QRCode onSuccess={onQrSuccess} />}
      </Stack>
      {patient && (
        <Stack direction="row" sx={styles.patientInfoStack}>
          <Box sx={styles.logo}>
            <Typography sx={styles.initials}>{getInitials()}</Typography>
          </Box>
          <Tooltip
            title={`${patient.firstName} ${patient.lastName}`}
            placement="bottom-start"
            enterTouchDelay={0}
            leaveTouchDelay={500}
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "offset",
                    options: { offset: [0, -8] },
                  },
                ],
              },
            }}
          >
            <Typography sx={styles.patientInfo}>
              {truncatedFirstName.text} {truncatedLastName.text}
            </Typography>
          </Tooltip>
        </Stack>
      )}
    </Stack>
  );
};

export default PatientInfoHeader;
